<section class="datatable report-datatable-card" [class.report-datatable-card--sticky-header]="iStickyHeader">
            <form [formGroup]="dtForm" *ngIf="iShowHeader">
                <header class="datatable__header report-datatable-card__header">
                    <div class="datatable-toolbar report-datatable-toolbar">
                        <div class="datatable-toolbar-start report-datatable-toolbar__start">
                            <div class="datatable__search">
                                <div *ngIf="iShowSearch" class="datatable__search-field">
                                    <i-feather name="search"></i-feather>
                                    <input id="txtSearchQuery" type="text" formControlName="searchQuery" placeholder="{{ 'SEARCH' | translate }}" class="datatable__search-input"
                                        aria-controls="tickets-table" (keydown.enter)="doServerSearch($event)">
                                </div>
                                <div class="hide-from-980">
                                    <button *ngIf="!iHideHeaderActions && (isAdmin || iShowExport)" type="button" class="blue-button"
                                    (click)="exportToCsv()">{{ 'EXPORT' | translate }}</button>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="iReportTitle" class="report-datatable-toolbar__title-wrap">
                            <div class="report-datatable-toolbar__title-filter">
                                <div>
                                    <h4 class="datatable-title">{{ iReportTitle | titlecase }}</h4>
                                </div>
                            </div>
                        </div>
                        <div class="datatable-toolbar-end hide-from-small report-datatable-toolbar__end">
                            <div class="datatable__pagination-group">
                                <ng-select class="datatable__select"
                                    [clearable]="false"
                                    [searchable]="false"
                                    [ngModel]="pageSize"
                                    [ngModelOptions]="{standalone: true}"
                                    (change)="onPageSizeChange($event)">
                                    <ng-option [value]="10">{{ 'COUNT_PER_PAGE' | translate:{count:10} }}</ng-option>
                                    <ng-option [value]="25">{{ 'COUNT_PER_PAGE' | translate:{count:25} }}</ng-option>
                                    <ng-option [value]="50">{{ 'COUNT_PER_PAGE' | translate:{count:50} }}</ng-option>
                                    <ng-option [value]="100">{{ 'COUNT_PER_PAGE' | translate:{count:100} }}</ng-option>
                                    <ng-option [value]="250">{{ 'COUNT_PER_PAGE' | translate:{count:250} }}</ng-option>
                                    <ng-option [value]="500">{{ 'COUNT_PER_PAGE' | translate:{count:500} }}</ng-option>
                                </ng-select>
                                <div *ngIf="iShowPagination" class="datatable__pagination pagination-rounded">
                                    <ngb-pagination [maxSize]="1" [rotate]="true" [ellipses]="true"
                                        [collectionSize]="collectionSize" [page]="pageNumber" [boundaryLinks]="true"
                                        (pageChange)="onPageChange($event)" [pageSize]="f.pageSize.value">
                                    </ngb-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </form>
            <div class="datatable__body report-datatable-card__body">
                <div class="report-datatable-table-wrap">
                <table #reportTable cellspacing="0" cellpadding="0" id="datatable" class="datatable__table report-datatable-table">
                    <colgroup>
                        <ng-container *ngFor="let col of iColumns">
                            <col *ngIf="col.visible === undefined || col.visible"
                                [style.width]="col.width || null"
                                [style.min-width]="col.width || null"
                                [style.max-width]="col.width || null">
                        </ng-container>
                        <col *ngIf="(iShowActions || iShowViewAction)">
                    </colgroup>
                    <thead>
                        <tr>
                            <ng-container *ngFor="let col of iColumns; let i=index">
                                <th *ngIf="col.visible === undefined || col.visible" dtSortable
                                    [style.width]="col.type === 'html' && col.width ? col.width : null"
                                    [style.min-width]="col.type === 'html' && col.width ? col.width : null"
                                    [style.max-width]="col.type === 'html' && col.width ? col.width : null"
                                    [attr.sortable]="(col.sortable  && col.sortable)? col.field : null"
                                    [sortable]="(col.sortable  && col.sortable)? col.field : null"
                                    (sort)="onSort($event, col)">
                                    <span>{{ col.title | translate }}</span>
                                    <ng-container *ngIf="col.title === '' && col.field === 'media'">
                                        <i class="far fa-image fa-2x"></i>
                                    </ng-container>
                                    <ng-container *ngIf="col.title === '' && col.field === 'html'">
                                        <i class="fas fa-code fa-2x"></i>
                                    </ng-container>
                                </th>
                            </ng-container>
                            <th *ngIf="(iShowActions || iShowViewAction)">
                                {{ 'ACTIONS' | translate }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="viewData.length==0">
                            <td class="datatable-empty-state"
                                [attr.colspan]="(iColumns.length + 1) + ( iShowActions ? 1 :0)">
                                {{ 'NO_DATA_FOUND' | translate }}
                            </td>
                        </tr>
                        <tr [style.color]="row.isDeleted ? 'red' : null" [ngClass]="row.statusColor ? row.statusColor : ''" *ngFor="let row of viewData; let i=index">
                            <ng-container *ngFor="let col of iColumns; let j=index">
                            <td [ngClass]="extractFieldValue(row, col.statusClass,'', []) ? extractFieldValue(row, col.statusClass,'', []) : ''" class="datatable-cell"
                                [style.width]="col.type === 'html' && col.width ? col.width : null"
                                [style.min-width]="col.type === 'html' && col.width ? col.width : null"
                                [style.max-width]="col.type === 'html' && col.width ? col.width : null"
                                *ngIf="!row.NoDataForReportingPeriod || j < 2"
                                [class.no-data-for-reporting-period]="row.NoDataForReportingPeriod && j === 1"
                                [attr.colspan]="row.NoDataForReportingPeriod && j === 1 ? iColumns.length - 1 : null">
                                <ng-container *ngIf="!row.NoDataForReportingPeriod || j === 0; else noDataForReportingPeriod">
                                <label class="task-label">{{ col.title | translate }}: </label>
                                <span *ngIf="(col.visible === undefined || col.visible )"
                                    (click)="oRowClick.emit(row)" [routerLink]="getRowLink(row).routerLink"
                                    [queryParams]="getRowLink(row).queryParams" role="link"
                                    >
                                    <div *ngIf="col.anchorLink && col.anchorLink; else html">
                                        <a class="datatable-anchor-link" [href]="getAnchorLink(col.anchorType, row[col.anchorParamsField])" [attr.target]="col.openInNewTab ? '_blank' : '_self'">
                                            {{row[col.field]}}
                                        </a>
                                    </div>
                                    <ng-template #html>
                                        <div *ngIf="col.type === 'html'; else image"
                                            [innerHTML]="SafeHtml(row[col.field])">
                                        </div>
                                    </ng-template>
                                    <ng-template #image>
                                        <div *ngIf="col.type === 'image'; else normal">
                                            <img [src]="SafeUrl(extractFieldValue(row, col.field,col.pipe, col?.pipeArgs))" 
                                                 [style.width]="col.width ? col.width : 'auto'" 
                                                 [style.height]="col.width ? 'auto' : null" />
                                        </div>
                                    </ng-template>
                                    <ng-template #normal>
                                        <ng-container *ngIf="col.translate; else noTranslateCell">
                                            <ngb-highlight
                                                (mouseover)="col.hoverValue ? showTooltip($event, extractFieldValue(row, col.hoverValue, col.pipe, col?.pipeArgs), true) : null"
                                                (mouseout)="hideTooltip()"
                                                [result]="extractFieldValue(row, col.field, col.pipe, col?.pipeArgs) | translate">
                                            </ngb-highlight>
                                        </ng-container>
                                        <ng-template #noTranslateCell>
                                            <ngb-highlight
                                                (mouseover)="col.hoverValue ? showTooltip($event, extractFieldValue(row, col.hoverValue, col.pipe, col?.pipeArgs), false) : null"
                                                (mouseout)="hideTooltip()"
                                                [result]="extractFieldValue(row, col.field, col.pipe, col?.pipeArgs)">
                                            </ngb-highlight>
                                        </ng-template>
                                    </ng-template>
                                </span>
                                </ng-container>
                                <ng-template #noDataForReportingPeriod>
                                    No data for this reporting period
                                </ng-template>
                            </td>
                            </ng-container>
                            <td *ngIf="( iShowActions || iShowViewAction )">
                                <div class="actions-container">
                                    <a *ngIf="iShowViewAction && (isAdmin || iCanRead)" class="a-btn"
                                        (click)="viewRow(row);$event.stopPropagation();"
                                        [attr.title]="'VIEW' | translate">
                                        <i-feather name="eye"></i-feather>
                                    </a>
                                    <a *ngIf="iShowExternalAction && (isAdmin || iCanRead)" class="a-btn"
                                        (click)="showExternal(row);$event.stopPropagation();"
                                        [attr.title]="'OPENS_ON_NEW_PAGE' | translate">
                                        <i-feather name="external-link"></i-feather>
                                    </a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot *ngIf="totalData.length > 0">
                        <tr class="report-datatable-summary-row" #summaryRow>
                            <td [ngClass]="extractFieldValue(totalData[0], col.statusClass,'', []) ? extractFieldValue(totalData[0], col.statusClass,'', []) : ''" *ngFor="let col of iColumns; let i = index">
                                <span class="report-datatable-summary-cell" [class.report-datatable-summary-cell--value-only]="i === 0" *ngIf="totalData[0][col.field] !== undefined">
                                    <span class="report-datatable-summary-cell__label" *ngIf="averageData.length <= 0 && i !== 0">{{ col.title | translate }}</span>
                                    <span class="report-datatable-summary-cell__value" (mouseover)="col.hoverValue ? showTooltip($event, extractFieldValue(totalData[0], col.hoverValue, col.pipe, col?.pipeArgs), !!col.translate) : null"
                                    (mouseout)="hideTooltip()">
                                        <ng-container *ngIf="i === 0; else totalValue">
                                            {{ 'TOTAL' | translate }}
                                        </ng-container>
                                        <ng-template #totalValue>
                                            <ng-container *ngIf="col.translate; else noTranslateTotal">
                                            {{ extractFieldValue(totalData[0], col.field, col.pipe, col.pipeArgs) | translate }}
                                            </ng-container>
                                        </ng-template>
                                        <ng-template #noTranslateTotal>
                                            {{ extractFieldValue(totalData[0], col.field, col.pipe, col.pipeArgs) }}
                                        </ng-template>
                                    </span>
                                </span>
                                <span *ngIf="totalData[0][col.field] === undefined"></span>
                            </td>
                            <td *ngIf="(iShowActions || iShowViewAction)"></td>
                        </tr>
                    </tfoot>
                    <tfoot *ngIf="averageData.length > 0">
                        <tr class="report-datatable-summary-row" #summaryRow>
                            <td [ngClass]="extractFieldValue(averageData[0], col.statusClass,'', []) ? extractFieldValue(averageData[0], col.statusClass,'', []) : ''" *ngFor="let col of iColumns; let i = index">
                                <span class="report-datatable-summary-cell" [class.report-datatable-summary-cell--value-only]="i === 0" *ngIf="averageData[0][col.field] !== undefined">
                                    <span class="report-datatable-summary-cell__label" *ngIf="i !== 0">{{ col.title | translate }}</span>
                                    <span class="report-datatable-summary-cell__value" (mouseover)="col.hoverValue ? showTooltip($event, extractFieldValue(averageData[0], col.hoverValue, col.pipe, col?.pipeArgs), !!col.translate) : null"
                                    (mouseout)="hideTooltip()">
                                        <ng-container *ngIf="i === 0; else averageValue">
                                            {{ 'AVERAGES' | translate }}
                                        </ng-container>
                                        <ng-template #averageValue>
                                            <ng-container *ngIf="col.translate; else noTranslateAvg">
                                            {{ extractFieldValue(averageData[0], col.field, col.pipe, col.pipeArgs) | translate }}
                                            </ng-container>
                                        </ng-template>
                                        <ng-template #noTranslateAvg>
                                            {{ extractFieldValue(averageData[0], col.field, col.pipe, col.pipeArgs) }}
                                        </ng-template>
                                    </span>
                                </span>
                                <span *ngIf="averageData[0][col.field] === undefined"></span>
                            </td>
                            <td *ngIf="(iShowActions || iShowViewAction)"></td>
                        </tr>
                    </tfoot>
                </table>
                </div>
                <div id="{{iReportTitle}}hoverValue" class="hoverValue" [innerHTML]="tooltipText"></div>
            </div>
            <form [formGroup]="dtForm" *ngIf="iShowFooter">
                <footer class="datatable__footer report-datatable-card__footer">
                    <div class="datatable-toolbar-end">
                        <div class="datatable__pagination-group">
                            <ng-select class="datatable__select"
                                [clearable]="false"
                                [searchable]="false"
                                [ngModel]="pageSize"
                                [ngModelOptions]="{standalone: true}"
                                (change)="onPageSizeChange($event)">
                                <ng-option [value]="10">{{ 'COUNT_PER_PAGE' | translate:{count:10} }}</ng-option>
                                <ng-option [value]="25">{{ 'COUNT_PER_PAGE' | translate:{count:25} }}</ng-option>
                                <ng-option [value]="50">{{ 'COUNT_PER_PAGE' | translate:{count:50} }}</ng-option>
                                <ng-option [value]="100">{{ 'COUNT_PER_PAGE' | translate:{count:100} }}</ng-option>
                                <ng-option [value]="250">{{ 'COUNT_PER_PAGE' | translate:{count:250} }}</ng-option>
                                <ng-option [value]="500">{{ 'COUNT_PER_PAGE' | translate:{count:500} }}</ng-option>
                            </ng-select>
                            <div class="datatable__pagination pagination-rounded">
                                <ngb-pagination [maxSize]="1" [rotate]="true" [ellipses]="true"
                                    [collectionSize]="collectionSize" [page]="pageNumber" [boundaryLinks]="true"
                                    (pageChange)="onPageChange($event)" [pageSize]="f.pageSize.value">
                                </ngb-pagination>
                            </div>
                        </div>
                    </div>
                </footer>
            </form>
</section>
